import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    info: (count: number) => {
      return translate({
        id: 'recurrenceSettings.recurrenceEnd.occurrencePicker.info',
        values: { count },
      })
    },
  }))

  return api
}
